"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorKind = void 0;
const react_1 = __importDefault(require("react"));
const Button_1 = require("decentraland-ui/dist/components/Button/Button");
const isEmail_1 = __importDefault(require("validator/lib/isEmail"));
const usePatchState_1 = __importDefault(require("../../hooks/usePatchState"));
const TokenList_1 = __importDefault(require("../../utils/dom/TokenList"));
const env_1 = __importDefault(require("../../utils/env"));
const variables_1 = require("../../variables");
const Input_1 = __importDefault(require("./Input"));
require("isomorphic-fetch");
require("./Subscribe.css");
var ErrorKind;
(function (ErrorKind) {
    ErrorKind[ErrorKind["None"] = 0] = "None";
    ErrorKind[ErrorKind["InvalidEmail"] = 1] = "InvalidEmail";
    ErrorKind[ErrorKind["ServerError"] = 2] = "ServerError";
})(ErrorKind = exports.ErrorKind || (exports.ErrorKind = {}));
const DEFAULT_ACTION = (0, env_1.default)('SUBSCRIBE_TARGET', 'https://subscription.decentraland.org/subscribe');
function Subscribe(props) {
    const [state, patchState] = (0, usePatchState_1.default)({
        email: '',
        loading: false,
        error: ErrorKind.None,
    });
    const intl = Object.assign({ cta: 'Sign up', inputError: 'Invalid email', serverError: 'Server error' }, props.intl);
    const placeholder = props.placeholder || 'email@domain.com';
    const action = props.action || DEFAULT_ACTION;
    const loading = props.loading || state.loading;
    const error = props.error || state.error;
    function handleChange(event) {
        patchState({ email: event.target.value, error: ErrorKind.None });
    }
    function handleSubmit(event) {
        const data = {
            email: state.email,
        };
        if (props.interest) {
            data.interest = props.interest;
        }
        if (props.lang) {
            data.lang = props.lang;
        }
        if (props.onSubmit) {
            props.onSubmit(event, data);
            if (event.isDefaultPrevented()) {
                return;
            }
        }
        event.preventDefault();
        if (!(0, isEmail_1.default)(data.email)) {
            patchState({ error: ErrorKind.InvalidEmail });
            return;
        }
        patchState({ loading: true });
        const req = props.method === 'GET'
            ? fetch(action +
                '?' +
                new URLSearchParams(data).toString())
            : fetch(action, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });
        req
            .then((response) => {
            patchState({
                loading: false,
                error: response.status >= 400 ? ErrorKind.ServerError : ErrorKind.None,
            });
            if (props.onSubscribe) {
                props.onSubscribe(data);
            }
        })
            .catch(() => patchState({ loading: false, error: ErrorKind.ServerError }));
    }
    let inputMessage;
    switch (error) {
        case ErrorKind.InvalidEmail:
            inputMessage = intl.inputError;
            break;
        case ErrorKind.ServerError:
            inputMessage = intl.serverError;
            break;
    }
    return (react_1.default.createElement("form", { className: TokenList_1.default.join([variables_1.StyleNamespace, 'Subscribe', props.className]), action: action, onSubmit: handleSubmit },
        react_1.default.createElement(Input_1.default, { defaultValue: props.defaultValue, placeholder: placeholder, error: !!inputMessage, message: inputMessage, disabled: props.disabled || loading, value: state.email, onChange: handleChange }),
        react_1.default.createElement(Button_1.Button, { primary: props.primary, inverted: props.inverted, basic: props.basic, disabled: props.disabled, loading: loading, type: "submit" }, intl.cta)));
}
exports.default = Subscribe;
